<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip || 'Mode plein écran'"
    (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:arrows-expand'" class="text-slate-300"></mat-icon>
</ng-template>
